import Vue from 'vue'
import App from '@/App.vue'
import Router from 'vue-router'
import { router } from '@/router.js'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import i18n from '@/lang'
import VueI18n from 'vue-i18n'
import VueMeta from 'vue-meta'
import vuetify from '@/plugins/vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import dbs from '@/data/dbs_simplified.json'

Vue.config.productionTip = false

Vue.use(Router)
Vue.use(VueI18n)
Vue.use(VueMeta)
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  loaderOptions: {
    explicitRenderParameters: {
      badge: 'none',
      autoHideBadge: false,
    }
  }
})

router.beforeEach((to, from, next) => {
  var topath = to.path
  var query = to.query
  if (topath.startsWith('/eng/hk/')){
    topath = topath.replace('/eng/hk/', '/en/')
    if (topath.endsWith('.html')){
      topath = topath.slice(0, -5)
    }
  }
  if (topath.startsWith('/chi/hk/')){
    topath = topath.replace('/chi/hk/', '/tc/')
    if (topath.endsWith('.html')){
      topath = topath.slice(0, -5)
    }
  }

  if (to.name.endsWith('db') && !topath.endsWith('/')){
    topath = topath + '/'
    next({path: topath, query: query})  // will enter this beforeEach again
  }
  
  if (!to.name.endsWith('db') && to.name != 'home' && topath.endsWith('/')){
    topath = topath.slice(0, -1)
    next({path: topath, query: query})  // will enter this beforeEach again
  }

  if ('lang' in to.params){
    if(
      (!['appeal-history'].includes(to.name)) 
      && (!['en', 'tc', 'sc'].includes(to.params.lang) 
      || dbs.findIndex(db => topath.includes(db.path)) < 0)
    ){
      next({name: '404'})
    }
  }
  next()
})

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
